import React from "react";
import Default from "./default";
import LifeMiles from "./lifemiles";

// TODO: Ajustar esto para que tome país también
const heros = {
  LifeMiles: LifeMiles
};

// TODO: Cambiar como se setea el default
export default props => {
  const Hero = heros[props.variaciones[0].producto] || Default;
  return <Hero {...props} />;
};
